export const getChangeData = ({
    modifier,
    option,
    defaultOptionValue,
    position,
    opponent,
    state,
    participants,
    modifierFieldMap,
}) => {

    let selectField;
    let selectSelected = [participants[position]];
    let deselectField;
    let deselectSelected = [participants[position]];
    const alternateModifier = Object.keys(modifierFieldMap).filter(mod => mod !== modifier)[0];

    if (option === defaultOptionValue) {

        selectField = alternateModifier
            ? state[position][alternateModifier].value === defaultOptionValue
                ? modifierFieldMap[modifier][defaultOptionValue]
                : null
            : modifierFieldMap[modifier][defaultOptionValue];
        selectSelected = (
            participants[opponent]
            && state[opponent][modifier].value === defaultOptionValue
            && (
                alternateModifier
                    ? state[opponent][alternateModifier].value === defaultOptionValue
                    : true
            )
        )
            ? [
                participants[opponent],
                participants[position],
            ]
            : [participants[position]];

    } else {

        selectField = modifierFieldMap[modifier][option];
        selectSelected = (state[opponent][modifier].value === option)
            ? [
                participants[opponent],
                participants[position],
            ]
            : [participants[position]];

    }

    deselectField = modifierFieldMap[modifier][state[position][modifier].value];

    return {
        selectField,
        selectSelected,
        deselectField,
        deselectSelected,
    };

};

export const getParticipantPlacement = ({
    participants,
    participantA,
    participantB,
    participantAState,
    participantBState,
    TOP,
    BOTTOM,
}) => {

    if (
        participants[TOP] === null
        && participants[BOTTOM] === null
    ) {

        return {
            topParticipant: participantA,
            bottomParticipant: participantB,
            state: {
                [TOP]: participantAState,
                [BOTTOM]: participantBState,
            },
        };

    }

    let top;
    let bottom;
    let topState = participantAState;
    let bottomState = participantBState;

    if (participants[TOP]?.value === participantA?.value) {

        top = participantA;
        topState = participantAState;

    } else if (participants[TOP]?.value === participantB?.value) {

        top = participantB;
        topState = participantBState;

    } else if (
        participants[TOP] === null
        && participants[BOTTOM]?.value !== participantA?.value
    ) {

        top = participantA;
        topState = participantAState;

    }

    if (participants[BOTTOM]?.value === participantB?.value) {

        bottom = participantB;
        bottomState = participantBState;

    } else if (participants[BOTTOM]?.value === participantA?.value) {

        bottom = participantA;
        bottomState = participantAState;

    } else if (
        participants[BOTTOM] === null
        && participants[TOP]?.value !== participantA?.value
    ) {

        bottom = participantA;
        bottomState = participantAState;

    } else if (
        participants[BOTTOM] === null
    ) {

        bottom = participantB;
        bottomState = participantBState;

    }

    return {
        topParticipant: top,
        bottomParticipant: bottom,
        state: {
            [TOP]: topState,
            [BOTTOM]: bottomState,
        },
    };

};
